import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Container = styled.section`
  display: flex;
  font-family: ${props => props.theme.fontFamilyBody};
  justify-content: space-between;
  align-items: center;
  margin-top: 18px;
`;

const Code = styled.a`
  height: 20px;
  padding: 4px;
  border-radius: 2px;
  background-color: ${props => props.theme.secondaryColor};
  color: white;
  font-size: 10px;
  line-height: 12px;
  font-weight: ${props => props.theme.fontWeightHeavy};
  text-transform: uppercase;
  text-align: center;

  &&:hover {
    color: white;
    text-decoration: none;
  }
`;

const Name = styled.a`
  margin-right: 8px;
  font-weight: ${props => props.theme.fontWeightBold};
  font-size: 14px;
  line-height: 20px;
  color: ${props => props.theme.bodyColor};
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;

  &&:hover {
    color: ${props => props.theme.bodyColor};
  }
`;

export default function StockCode({ stockCode }) {
  return (
    <Container>
      <Name
        href={`/stock_codes/${stockCode.slug}`}
        data-stock-code={stockCode.code}
      >
        {_.startCase(_.lowerCase(stockCode.companyName))}
      </Name>
      <Code
        href={`/stock_codes/${stockCode.slug}`}
        data-stock-code={stockCode.code}
      >
        {stockCode.code}
      </Code>
    </Container>
  );
}

StockCode.propTypes = {
  stockCode: PropTypes.shape({
    id: PropTypes.number.isRequired,
    code: PropTypes.string.isRequired,
    companyName: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
  }).isRequired,
};
